import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  customer: null,
  name: '',
  variant: '',
  brand: '',
  category: '',
  packaging: '',
  size: '',
  weight: null,
  volume: null,
};

export const FormInput = ({ item, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { customer, name, variant, brand, category, packaging, size, weight, volume },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  React.useEffect(() => {
    const input = {
      customer,
      name,
      variant,
      brand,
      category,
      packaging,
      size,
      weight,
      volume,
    };

    onInputChange(input);
  }, [customer, name, variant, brand, category, packaging, size, weight, volume]);

  React.useEffect(() => {
    if (!item) return;

    setState((prevState) => ({
      ...prevState,
      customer: item?.tenant,
      name: item?.name,
      variant: item?.variant,
      brand: item?.brand,
      category: item?.category,
      packaging: item?.packaging,
      size: item?.size,
      weight: item?.weight,
      volume: item?.volume,
    }));
  }, [item]);

  return (
    <div className="mt-3">
      {loading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-4" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="row border-bottom ">
          <div className="col-md-6 border-end pe-md-4 pe-0">
            <div className="fw-semibold py-2 fs-6">Informasi Item</div>
            {!item && (
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Customer"
                  placeholder=""
                  url="/partner"
                  params={{type: 'customer'}}
                  value={customer}
                  initialValue={customer?.id}
                  row={(d) => {
                    return {
                      value: d.id,
                      label: d?.company_name
                        ? `${d.name} - ${d.company_name}`
                        : `${d.name}`,
                    };
                  }}
                  keys={customer?.id}
                  onSelected={(c) => {
                    setState((prevState) => ({
                      ...prevState,
                      customer: c
                    }));
                  }}
                  errors={StateForm?.errors?.tenant_id}
                />
              </div>
            )}

            <div className="py-3">
              <Form.Input
                required
                label="Nama"
                type="text"
                value={name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.name}
              />
              <Form.Input
                label="Merek"
                type="text"
                value={brand}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    brand: e.target.value,
                  }))
                }
                error={StateForm?.errors?.brand}
              />
              <Form.Input
                label="Varian"
                type="text"
                value={variant}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    variant: e.target.value,
                  }))
                }
                error={StateForm?.errors?.variant}
              />
              <Form.Input
                label="Kategori"
                required
                type="text"
                value={category}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    category: e.target.value,
                  }))
                }
                error={StateForm?.errors?.category}
              />
            </div>
          </div>
          <div className="col-md-6 px-md-4 px-0">
            <div className="fw-semibold py-2 fs-6">Informasi Kemasan</div>
            <div className="py-3">
              <Form.Input
                label="Kemasan"
                type="text"
                value={packaging}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    packaging: e.target.value,
                  }))
                }
                error={StateForm?.errors?.packaging}
              />
              <Form.Input
                label="Ukuran"
                type="text"
                value={size}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    size: e.target.value,
                  }))
                }
                error={StateForm?.errors?.size}
              />
              <Form.Input
                required
                label="Berat (Gram)"
                type="number"
                value={weight}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    weight: e.target.valueNumber,
                  }))
                }
                error={StateForm?.errors?.weight}
              />
              <Form.Input
                label="Volume"
                type="number"
                value={volume}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    volume: e.target.valueNumber,
                  }))
                }
                error={StateForm?.errors?.volume}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
